import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getInteractions] = createSelectors(MODULE, ["interactions"]);

// The ISO timestamp of when a user last acted on the given element, or undefined
// if they never have.
export const getInteractionAt = (state, key) => getInteractions(state)?.[key];
